import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Logos from './components/Logos';
import Features from './components/Features';
import FeatureGrid from './components/FeatureGrid';
import Stats from './components/Stats';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';
import ScrollToTop from './components/ScrollToTop';

function Homepage() {
  return (
    <main>
      <Hero />
      <Logos />
      <Features />
      <FeatureGrid />
      <Stats />
      <Testimonials />
      <FAQ />
      <CTA />
    </main>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="bg-white min-h-screen font-sans text-gray-900 selection:bg-blue-100 selection:text-blue-900">
        <Header />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about-us" element={<AboutUs title="About Us - Easy Hiring" />} />
          <Route path="/contact" element={<Contact title="Contact Us - Easy Hiring" />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
